module.exports = __webpack_public_path__ + "img/grandfather.be5030ca.webp";